import React from 'react';

export const Profile = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='21'
    height='21'
    viewBox='0 0 21 21'
    fill='none'
    stroke='#11387f'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <circle cx='12' cy='7' r='4' />
    <path d='M12 14s-8-1.5-8 4h16c0-5.5-8-4-8-4z' />
  </svg>
);
